import { getAPIHost } from '@rsos/utils/metaTags';
import doFetch from '../actions/doFetch';

const baseURL = `${getAPIHost()}/v1/capstone`;

/* Jira */

export const getIssues = psapName =>
  doFetch(`${baseURL}/psaps/${psapName}/customer-requests`);

export const postIssue = (issue, psapName) => {
  return doFetch(`${baseURL}/psaps/${psapName}/customer-requests`, {
    method: 'POST',
    body: issue,
  });
};

export const patchIssue = (issue, psapName, status) => {
  return doFetch(
    `${baseURL}/psaps/${psapName}/customer-requests/${issue.issue_key}`,
    {
      method: 'PATCH',
      body: {
        status,
      },
    },
  );
};

export const postIssueComment = (issue, psapName, comment) => {
  return doFetch(
    `${baseURL}/psaps/${psapName}/customer-requests/${issue.issue_key}/comments`,
    {
      method: 'POST',
      body: { body: comment },
    },
  );
};
